export default __webpack_public_path__ + "static/media/success-2.2d1042da.jpg";